import { db } from '../App';
import { collection, doc, setDoc, getDoc, updateDoc } from 'firebase/firestore';

const generateShortId = () => Math.random().toString(36).substring(2, 8);

export const createGame = async (playerId) => {
  const gameId = generateShortId();
  const gameDocRef = doc(collection(db, 'games'), gameId);

  const gameData = {
    player1: playerId,
    player2: null,
    status: 'waiting'
  };

  await setDoc(gameDocRef, gameData);
  return gameId;
};

export const joinGame = async (gameId, playerId) => {
  const gameDocRef = doc(db, 'games', gameId);
  const gameDocSnap = await getDoc(gameDocRef);

  if (gameDocSnap.exists() && gameDocSnap.data().player2 === null) {
    await updateDoc(gameDocRef, { player2: playerId, status: 'started' });
    return true;
  }

  return false;
};

export const getGameData = async (gameId) => {
  const gameDocRef = doc(db, 'games', gameId);
  const gameDocSnap = await getDoc(gameDocRef);
  return gameDocSnap.exists() ? gameDocSnap.data() : null;
};
